import { useGetCompanyQuery } from "@/api/AppApi/services/company";
import { unit } from "@/api/AppApi/services/product/interfaces/api-product-details-interface";
import BaseOption from "@/app/components/common-filter-builder/common-filters-components/base-checkbox/BaseOption";
import { useCurrencyCalc } from "@/hooks/useCurrencyCalc";

type TProps = {
  unitName: unit["name"];
  unitId: unit["id"];
  isSelected: boolean;
  onSelect: (unitId: unit["id"]) => void;
  price: unit["price"];
};

const CartItemUnitDropdownItem: React.FC<TProps> = ({
  isSelected,
  onSelect,
  unitId,
  unitName,
  price,
}) => {
  const { data } = useGetCompanyQuery();
  const { currency, getPriceString } = useCurrencyCalc({
    enable: data?.result?.theme?.settings?.
enable_currencies_converter ?? true,
  });
  return (
    <div
      className={`cart-item-units-menu-item ${
        isSelected
          ? "cart-item-units-menu-item-checked"
          : "cart-item-units-menu-item-unchecked"
      } `}
      onClick={() => onSelect(unitId)}
    >
      <div className="cart-item-units-menu-container">
        <BaseOption
          is_multi_select={false}
          label={unitName}
          selected={isSelected}
          toggleOption={() => {}}
        />
        {getPriceString(price)} {currency.code}
      </div>
    </div>
  );
};

export default CartItemUnitDropdownItem;
